import React, { useEffect, useRef } from "react";
import Routes from "./routes";

const App: React.FC = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "url('/images/background.jpg') no-repeat center center fixed",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "600px",
          height: "100%",
          background:
            "linear-gradient(to bottom, #F8AECC 0%, #FB7B9F 32%, #FB7B9F 96%)",
          position: "relative",
        }}
      >
        <Routes />
      </div>
    </div>
  );
};

export default App;
